export default __webpack_public_path__ + "static/media/median-icon.cd13df35.svg";